import React, { useCallback } from 'react';
import { Checkbox } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { LiftOptions } from '@search/filter-enums/enums/LiftOptions';
import { ParkingType } from '@search/filter-enums/enums';
import { InfrastructureOptions } from '@search/filter-enums/enums/InfrastructureOptions';

import { InfrastructureFilter } from '../../../models/Filter';
import { ParkingFilter } from '../../../models/Filter';

import './style.css';

const cn = classname.bind(null, 'MoreFilterView');

interface IInfrastructureButtonFilterView {
    filter: InfrastructureFilter;
    parkingFilter: ParkingFilter;
    handleChange: (value: InfrastructureFilter | ParkingFilter) => void;
    classNameGroup?: string;
}

enum Infrastructure {
    Lift = 1,
    Consierge = 2,
    ClosedTerritory = 3
}

export const InfrastructureButtonFilterView: React.FC<IInfrastructureButtonFilterView> = ({
    filter,
    handleChange,
    parkingFilter,
    classNameGroup
}) => {
    const onChangeParking = useCallback((newValue: boolean) => {
        if (newValue) {
            handleChange(new ParkingFilter([
                ParkingType.CLOSED,
                ParkingType.OPEN,
                ParkingType.UNDERGROUND
            ]));
        } else {
            handleChange(new ParkingFilter());
        }
    }, [ handleChange ]);

    const onChange = useCallback((newValue: boolean, option: Infrastructure) => {
        const result = new Set(filter.infrastructure);

        let lift: LiftOptions | undefined = filter.hasLift;

        if (option === Infrastructure.Lift) {
            lift = newValue ? LiftOptions.HAS_ANY : undefined;
        }
        if (option === Infrastructure.Consierge) result[newValue ? 'add' : 'delete'](InfrastructureOptions.CONCIERGE);
        // eslint-disable-next-line max-len
        if (option === Infrastructure.ClosedTerritory) result[newValue ? 'add' : 'delete'](InfrastructureOptions.CLOSED_AREA);

        handleChange(new InfrastructureFilter(
            Array.from(result),
            lift
        ));
    }, [ handleChange, filter ]);

    return (
        <div className={classNameGroup}>
            <div className={cn('item')}>
                <Checkbox
                    key={Infrastructure.Consierge}
                    name='concierzh'
                    value={filter.infrastructure.includes(InfrastructureOptions.CONCIERGE)}
                    onChange={newValue => onChange(newValue, Infrastructure.Consierge)}
                    variant='filter'
                    block
                >
                    Консьерж
                </Checkbox>
            </div>
            <div className={cn('item')}>
                <Checkbox
                    key={Infrastructure.ClosedTerritory}
                    name='closed-area'
                    value={filter.infrastructure.includes(InfrastructureOptions.CLOSED_AREA)}
                    onChange={newValue => onChange(newValue, Infrastructure.ClosedTerritory)}
                    variant='filter'
                    block
                >
                    Закрытая территория
                </Checkbox>
            </div>
            <div className={cn('item')}>
                <Checkbox
                    key={Infrastructure.Lift}
                    name='elevator'
                    value={Boolean(filter?.hasLift)}
                    onChange={newValue => onChange(newValue, Infrastructure.Lift)}
                    variant='filter'
                    block
                >
                    Лифт
                </Checkbox>
            </div>
            <div className={cn('item')}>
                <Checkbox
                    key='Parking'
                    name='parking-checkbox'
                    value={parkingFilter.parkings.length > 0}
                    onChange={onChangeParking}
                    variant='filter'
                    block
                >
                    Парковка
                </Checkbox>
            </div>
        </div>
    );
};
